import { AustralianState, CampaignDetailModelState } from '@urbanx/agx.campaigns.client';
import { useAppSelector } from './useAppSelector';
import { AppFeatures } from '@urbanx/agx.agencies.client';

export const useFeatureToggles = (
  state?: AustralianState | CampaignDetailModelState
): AppFeatures & { isLoading: boolean } => {
  const { featureToggles } = useAppSelector((state) => state.agentInfo);

  if (!featureToggles || !state) return { isLoading: true };

  return { ...featureToggles[state], isLoading: false };
};
